export default __webpack_public_path__ + "static/media/announcement.69296076.svg";